
export class EditorTemplateOverviewService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    getEditorContentOverviewDetails(details) {
        return this._getOverviewDetails(details.data);
    }

    updateEditorContentOverviewDetails(details, moduleName) {
        this._setResourceUrl(moduleName);
        const promise = this.editorContentOverviewResource.update(this._setOverviewObject(details)).$promise;

        return promise.then(details => details.data)
            .catch((error) => {
                throw this.apiService.getErrorMessage(error);
            });
    }

    //*************************************Private Methods********************************** */

    _setResourceUrl(moduleName) {
        this.editorContentOverviewResourceUrl = this.apiService.getResourceUrl(`cms/menus/overview/${moduleName}`);
        this.editorContentOverviewResource = this.$resource(this.editorContentOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    _getOverviewDetails(details) {
        return {
            title: details.title,
            overview: details.overview,
            description: details.description,
            image: details.image,
            ada: details.ada || {}
        }
    }

    _setOverviewObject(details) {
        return {
            title: details.title,
            overview: details.overview,
            description: details.description,
            image: details.image,
            ada: details.ada || {}
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/editor-template-overview/editor-template-overview.service.js